export default {
  hasTriggeredScroll: (state) => state.hasTriggeredScroll,
  scrollThreshold: (state) => state.scrollThreshold,
};
